const DropDown = function (dropDownWrap, controlArea, settings) {

    let dropDownWrapper = dropDownWrap;
    let dropDownArea = dropDownWrap.find(".drop-down-area");
    let dropDownBody = dropDownWrap.find(".drop-down-body");
    let dropDownContent = dropDownWrap.find(".drop-down-content");

    let upParentAbsoluteElem = null;

    let currentElem = dropDownWrapper;
    while (!currentElem.is($("body"))) {
        if (currentElem.css("position") === "absolute") {
            if (!currentElem.parent().is($("body"))) {
                upParentAbsoluteElem = currentElem;
            }
        }
        currentElem = currentElem.parent();
    }

    if (upParentAbsoluteElem != null) {
        upParentAbsoluteElem.data("original-z", upParentAbsoluteElem.css("z-index"));
    }

    let ajaxContent = null;

    let dropDownSettings = {
        directionX: "right",
        directionY: "down",
        maxWidthControl: null,
        maxHeightControl: null,
        shiftX: 0,
        shiftY: 0,
        areaWrapper: isDefined(controlArea) ? controlArea : dropDownArea,
        showOnHover: dropDownArea.hasClass("on-hover"),
        ajaxHandle: null
    };

    if (isDefined(settings)) {
        parseOptions(dropDownSettings, settings);
    }
    if (dropDownSettings.maxWidthControl === null) {
        dropDownSettings.maxWidthControl = $(window);
    }
    if (dropDownSettings.maxHeightControl === null) {
        dropDownSettings.maxHeightControl = $(window);
    }

    Object.defineProperties(this, {
        dropDownWrapper: {
            get: function () {
                return dropDownWrapper;
            }
        },
        dropDownArea: {
            get: function () {
                return dropDownArea;
            }
        },
        dropDownBody: {
            get: function () {
                return dropDownBody;
            }
        },
        dropDownContent: {
            get: function () {
                return dropDownContent;
            }
        },
        upParentAbsoluteElem: {
            get: function () {
                return upParentAbsoluteElem;
            }
        },
        directionX: {
            get: function () {
                return dropDownSettings.directionX;
            },
            set: function (directionX) {
                dropDownSettings.directionX = directionX;
            }
        },
        directionY: {
            get: function () {
                return dropDownSettings.directionY;
            },
            set: function (directionY) {
                dropDownSettings.directionY = directionY;
            }
        },
        maxWidthControl: {
            get: function () {
                return dropDownSettings.maxWidthControl;
            },
            set: function (maxWidthControl) {
                dropDownSettings.maxWidthControl = maxWidthControl;
            }
        },
        maxHeightControl: {
            get: function () {
                return dropDownSettings.maxHeightControl;
            },
            set: function (maxHeightControl) {
                dropDownSettings.maxHeightControl = maxHeightControl;
            }
        },
        shiftX: {
            get: function () {
                return dropDownSettings.shiftX;
            },
            set: function (shiftX) {
                dropDownSettings.shiftX = shiftX;
            }
        },
        shiftY: {
            get: function () {
                return dropDownSettings.shiftY;
            },
            set: function (shiftY) {
                dropDownSettings.shiftY = shiftY;
            }
        },
        areaWrapper: {
            get: function () {
                return dropDownSettings.areaWrapper;
            }
        },
        showOnHover: {
            get: function () {
                return dropDownSettings.showOnHover;
            },
            set: function (showOnHover) {
                if (isBoolean(showOnHover)) {
                    dropDownSettings.showOnHover = showOnHover;
                }
            }
        },
        ajaxHandle: {
            set: function (ajaxHandle) {
                if (isFunction(ajaxHandle)) {
                    dropDownSettings.ajaxHandle = ajaxHandle;
                }
            }
        },
        ajaxContent: {
            get: function () {
                return ajaxContent;
            }
        },
    });

    this.loadAjaxData = function (callback) {
        dropDownSettings.ajaxHandle(function (data) {
            if (isDefined(data)) {
                ajaxContent = data;
                callback(true);
            }
        });
    };

    this.ajaxHandleIsSet = function () {
        return dropDownSettings.ajaxHandle != null;
    };

    this.checkBody = function () {

        if (!dropDownBody.length) {
            dropDownBody = $('<div class="drop-down-body"></div>');
            dropDownWrapper.append(dropDownBody);
        }

        if (!dropDownContent.length) {
            dropDownContent = $('<div class="drop-down-content"></div>');
            dropDownBody.append(dropDownContent);
        }

    };

};

DropDown.prototype.isFitInDirectionY = function (directionY) {

    let controlHeight = this.areaWrapper.outerHeight(true);
    let controlTop = this.areaWrapper.offset().top;

    let maxHeightControlTop = this.maxHeightControl.is($(window)) ? $(window).scrollTop() : this.maxHeightControl.offset().top;
    let maxHeightControlHeight = this.maxHeightControl.is($(window)) ? $(window).height() : this.maxHeightControl.outerHeight();

    let dropDownBodyMaxHeight = (maxHeightControlTop + maxHeightControlHeight) - (controlTop + controlHeight) - this.shiftY;
    let dropDownBodyMaxHeightReverse = controlTop - maxHeightControlTop - this.shiftY;

    let realDropDownHeight = this.dropDownContent.outerHeight(true);

    if (directionY === "up") {
        return realDropDownHeight <= dropDownBodyMaxHeightReverse || dropDownBodyMaxHeightReverse >= dropDownBodyMaxHeight;
    } else {
        return realDropDownHeight <= dropDownBodyMaxHeight || dropDownBodyMaxHeight >= dropDownBodyMaxHeightReverse;
    }

};

DropDown.prototype.isFitInDirectionX = function (directionX) {

    let controlWidth = this.areaWrapper.outerWidth(true);
    let controlLeft = this.areaWrapper.offset().left;

    let maxWidthControlLeft = this.maxWidthControl.is($(window)) ? 0 : this.maxWidthControl.offset().left;
    let maxWidthControlWidth = this.maxWidthControl.is($(window)) ? $(window).
    width() : this.maxWidthControl.outerWidth();

    let dropDownBodyMaxWidth = (maxWidthControlLeft + maxWidthControlWidth) - controlLeft - this.shiftX;
    let dropDownBodyMaxWidthReverse = controlLeft - maxWidthControlLeft + controlWidth - this.shiftX;

    let realDropDownWidth = this.dropDownContent.outerWidth(true);

    if (directionX === "right") {
        return realDropDownWidth <= dropDownBodyMaxWidth || dropDownBodyMaxWidth >= dropDownBodyMaxWidthReverse;
    } else {
        return realDropDownWidth <= dropDownBodyMaxWidthReverse || dropDownBodyMaxWidthReverse >= dropDownBodyMaxWidth;
    }

};

DropDown.prototype.setCorrectPosition = function () {

    let controlWidth = this.areaWrapper.outerWidth(true);
    let controlHeight = this.areaWrapper.outerHeight(true);
    let controlLeft = this.areaWrapper.offset().left;
    let controlTop = this.areaWrapper.offset().top;

    let maxHeightControlTop = this.maxHeightControl.is($(window)) ? $(window).
    scrollTop() : this.maxHeightControl.offset().top;
    let maxHeightControlHeight = this.maxHeightControl.is($(window)) ? $(window).
    height() : this.maxHeightControl.outerHeight(true);

    let dropDownBodyMaxHeight = (maxHeightControlTop + maxHeightControlHeight) - (controlTop + controlHeight) - this.shiftY;
    let dropDownBodyMaxHeightReverse = controlTop - maxHeightControlTop - this.shiftY;

    if (this.directionY === "up") {
        if (this.isFitInDirectionY(this.directionY)) {
            this.dropDownBody.css({
                top: "auto",
                bottom: controlHeight + this.shiftY,
                "height": dropDownBodyMaxHeightReverse + "px",
                "align-items": "flex-end"
            });
            this.dropDownContent.css("max-height", dropDownBodyMaxHeightReverse);
        } else {
            this.dropDownBody.css({
                top: controlHeight + this.shiftY,
                bottom: "auto",
                "height": dropDownBodyMaxHeight + "px",
                "align-items": "flex-start"
            });
            this.dropDownContent.css("max-height", dropDownBodyMaxHeight);
        }
    } else {

        if (this.isFitInDirectionY(this.directionY)) {
            this.dropDownBody.css({
                top: controlHeight + this.shiftY,
                bottom: "auto",
                "height": dropDownBodyMaxHeight + "px",
                "align-items": "flex-start"
            });
            this.dropDownContent.css("max-height", dropDownBodyMaxHeight);
        } else {
            this.dropDownBody.css({
                top: "auto",
                bottom: controlHeight + this.shiftY,
                "height": dropDownBodyMaxHeightReverse + "px",
                "align-items": "flex-end"
            });
            this.dropDownContent.css("max-height", dropDownBodyMaxHeightReverse);
        }
    }

    this.dropDownBody.css({"min-width": controlWidth});
    this.dropDownContent.css({"min-width": controlWidth});


    if (this.dropDownContent[0].scrollHeight > parseInt(this.dropDownBody.css("height"))) {
        this.dropDownContent.css("overflow-y", "scroll");
    }

    let maxWidthControlLeft = this.maxWidthControl.is($(window)) ? 0 : this.maxWidthControl.offset().left;
    let maxWidthControlWidth = this.maxWidthControl.is($(window)) ? $(window).width() : this.maxWidthControl.outerWidth();

    let dropDownBodyMaxWidth = (maxWidthControlLeft + maxWidthControlWidth) - controlLeft;
    let dropDownBodyMaxWidthReverse = controlLeft - maxWidthControlLeft + controlWidth;

    if (this.directionX === "right") {

        if (this.isFitInDirectionX(this.directionX)) {
            this.dropDownBody.css({
                "width": dropDownBodyMaxWidth,
                left: this.shiftX + "px",
                right: "auto",
                "justify-content": "flex-start"
            });
        } else {
            this.dropDownBody.css({
                "width": dropDownBodyMaxWidthReverse,
                left: "auto",
                right: this.shiftX + "px",
                "justify-content": "flex-end"
            });
        }

    } else {

        if (this.isFitInDirectionX(this.directionX)) {
            this.dropDownBody.css({
                "width": dropDownBodyMaxWidthReverse,
                left: "auto",
                right: this.shiftX + "px",
                "justify-content": "flex-end"
            });
        } else {
            this.dropDownBody.css({
                "width": dropDownBodyMaxWidth,
                left: this.shiftX + "px",
                right: "auto",
                "justify-content": "flex-start"
            });
        }

    }

};

DropDown.prototype.checkAbsoluteParent = function () {

    if (this.upParentAbsoluteElem != null) {
        this.upParentAbsoluteElem.css({"z-index": 99999999});
    }

};

DropDown.prototype.checkWrapperWidth = function () {
    this.dropDownWrapper.css('max-width', this.areaWrapper.outerWidth(true));
};

DropDown.prototype.isOpened = function () {
    return this.dropDownWrapper.hasClass('opened');
};

DropDown.prototype.show = function () {

    if (this.isOpened()) {
        return false;
    }

    $(document).find(".drop-down-wrap").not(this.dropDownWrapper).removeClass('opened');

    this.checkWrapperWidth();

    let self = this;

    if (self.ajaxHandleIsSet() && self.ajaxContent == null) {

        self.checkBody();
        self.setCorrectPosition();

        if (!self.dropDownBody.isVisible()) {
            self.dropDownWrapper.addClass('opened hover');
            self.checkAbsoluteParent();
        }

        let progress = $.progress.insert(self.dropDownContent);

        self.loadAjaxData(function (callback) {
            if (callback === true) {
                $.progress.remove(progress);
                self.dropDownContent.html(self.ajaxContent);
                self.setCorrectPosition();
            }
        });

    } else {

        self.checkBody();
        self.setCorrectPosition();

        if (!self.dropDownBody.isVisible()) {
            self.dropDownWrapper.addClass('opened hover');
            self.checkAbsoluteParent();
        }

    }

};

DropDown.prototype.hide = function () {

    if (this.dropDownWrapper.isVisible()) {
        this.dropDownWrapper.removeClass('opened hover');
        if (this.upParentAbsoluteElem != null) {
            this.upParentAbsoluteElem.css("z-index", this.upParentAbsoluteElem.data("original-z"));
        }
    }

};

DropDown.prototype.init = function () {

    if (isDefined(this.dropDownWrapper.data("instance"))) {
        return;
    }

    this.dropDownWrapper.data("instance", this);
};

const ToolTip = function (dropDownWrap, controlArea, settings) {

    DropDown.call(this, dropDownWrap, controlArea, settings);

    let tooltipArrow = this.dropDownBody.find(".tooltip-arrow");

    Object.defineProperties(this, {
        tooltipArrow: {
            get: function () {
                return tooltipArrow;
            }
        },
    });

    this.checkBodyT = function () {

        this.checkBody();

        if (!this.dropDownBody.find(".tooltip-arrow").length) {
            tooltipArrow = $('<div class="tooltip-arrow"></div>');
            this.dropDownBody.append(tooltipArrow);
        }

    };

};

ToolTip.prototype = Object.create(DropDown.prototype);

ToolTip.prototype.setShifts = function () {

    this.tooltipArrow.attr("class", "tooltip-arrow");
    let arrowHeight = this.tooltipArrow.height();

    switch (this.directionY) {
        case "up":
            if (this.isFitInDirectionY(this.directionY)) {
                this.tooltipArrow.addClass("arrow-down");
                this.tooltipArrow.css({
                    top: -arrowHeight + "px",
                    bottom: "auto"
                });
            } else {
                this.tooltipArrow.addClass("arrow-up");
                this.tooltipArrow.css({
                    bottom: -arrowHeight + "px",
                    top: "auto"
                });
            }
            break;
        case "down":
            if (this.isFitInDirectionY(this.directionY)) {
                this.tooltipArrow.addClass("arrow-up");
                this.tooltipArrow.css({
                    top: -arrowHeight + "px",
                    bottom: "auto"
                });
            } else {
                this.tooltipArrow.addClass("arrow-down");
                this.tooltipArrow.css({
                    bottom: -arrowHeight + "px",
                    top: "auto"
                });
            }
            break;
    }

    let areaWidth = this.areaWrapper.outerWidth(true);
    let arrowPosX = (areaWidth / 2) - (this.tooltipArrow.outerWidth(true) / 2);

    switch (this.directionX) {
        case "right":
            if (this.isFitInDirectionX(this.directionX)) {
                this.tooltipArrow.css({
                    left: arrowPosX + "px",
                    right: "auto"
                });
            } else {
                this.tooltipArrow.css({
                    left: "auto",
                    right: arrowPosX + "px"
                });
            }
            break;
        case "left":
            if (this.isFitInDirectionX(this.directionX)) {
                this.tooltipArrow.css({
                    left: "auto",
                    right: arrowPosX + "px"
                });
            } else {
                this.tooltipArrow.css({
                    left: arrowPosX + "px",
                    right: "auto"
                });
            }
            break;
    }

    this.shiftY = arrowHeight;

};

ToolTip.prototype.show = function () {

    if (this.dropDownWrapper.data("opened") === true) {
        return false;
    }

    $(document).find(".drop-down-wrap").not(this.dropDownWrapper).removeClass('opened');

    this.dropDownArea.css('width', this.dropDownArea.outerWidth(true));

    if (this.ajaxHandleIsSet() && this.ajaxContent == null) {

        this.checkBodyT();
        this.setShifts();
        this.setCorrectPosition();

        if (!this.dropDownBody.isVisible()) {
            this.dropDownWrapper.addClass('opened hover');
            this.checkAbsoluteParent();
        }

        let progress = $.progress.insert(this.dropDownContent);
        let self = this;

        this.loadAjaxData(function (callback) {
            if (callback === true) {
                $.progress.remove(progress);
                self.dropDownContent.html(self.ajaxContent);
                self.setCorrectPosition();
            }
        });

    } else {

        this.checkBodyT();
        this.setShifts();
        this.setCorrectPosition();

        if (!this.dropDownBody.isVisible()) {
            this.dropDownWrapper.addClass('opened hover');
            this.checkAbsoluteParent();
        }

    }

};

$(document).on("click touch", ".drop-down-wrap .drop-down-area", function (e) {

    let stop = false;
    if (isDefined($(this).data("no-prevent"))) {
        if ($(this).data("no-prevent")) {
            stop = true;
        }
    }

    if (!stop) {
        e.preventDefault();
        e.stopPropagation();
    }

    let instance = $(this).closest(".drop-down-wrap").data('instance');

    if (isDefined(instance)) {

        if (instance.isOpened()) {
            instance.hide();
        } else {
            instance.show();
        }

        $(document).on('click', function (e) {
            if (!instance.dropDownContent.is($(e.target)) && instance.dropDownContent.has($(e.target)).length === 0 && !$(e.target).closest(".drop-down-area").length) {
                instance.hide();
            }
        });

    }

});

$(document).on("mouseover touch", ".drop-down-wrap .drop-down-area", function (e) {

    let instance = $(this).closest(".drop-down-wrap").data('instance');

    if (isDefined(instance)) {
        if (instance.showOnHover) {
            instance.show();
            $(document).one('click', function (e) {
                if (!instance.dropDownContent.is($(e.target)) && instance.dropDownContent.has($(e.target)).length === 0 && !$(e.target).closest(".drop-down-area").length) {
                    instance.hide();
                }
            });
        }
    }

});

$(document).on('click', '.drop-down-wrap .close-drop-down', function (e) {

    e.preventDefault();

    let instance = $(this).closest(".drop-down-wrap").data('instance');

    if (isDefined(instance)) {
        instance.hide();
    }

});

let activeDropDown = null;
$(document).on('mouseover', function (e) {

    let target = $(e.target);

    if (activeDropDown === null) {
        if (target.closest('.drop-down-area').length) {
            activeDropDown = target.closest('.drop-down-wrap');
        }
    } else {

        let instance = activeDropDown.data('instance');
        let area = activeDropDown.find('.drop-down-area');
        let content = activeDropDown.find('.drop-down-content');

        let targetArea = target.closest('.drop-down-area');
        let targetContent = target.closest('.drop-down-content');

        if (!targetArea.is(area) && !targetContent.is(content)) {
            if (isDefined(instance)) {
                if (instance.showOnHover) {
                    instance.hide();
                    activeDropDown = null;
                }
            }
        }

    }

});

$(window).resize(function () {
    setTimeout(function () {
        $(document).find('.drop-down-wrap').each(function () {
            let instance = $(this).data('instance');
            if (isDefined(instance)) {
                instance.checkWrapperWidth();
            }
        });
    }, 50);
});